
import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { CartProvider } from './context/CartContext';
import { ProductModalProvider } from './context/ProductModalContext';
import ProductDetailModal from './components/feature/ProductDetailModal';
import CartDrawer from './components/feature/CartDrawer';
import FloatingRequestButton from './components/feature/FloatingRequestButton';
import ProductRequestDrawer from './components/feature/ProductRequestDrawer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [isRequestDrawerOpen, setIsRequestDrawerOpen] = useState(false);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <CartProvider>
        <ScrollToTop />
        <ProductModalProvider>
          <AppRoutes />
          <ProductDetailModal />
          <CartDrawer />
          {/* <FloatingRequestButton onClick={() => setIsRequestDrawerOpen(true)} />
          <ProductRequestDrawer 
            isOpen={isRequestDrawerOpen} 
            onClose={() => setIsRequestDrawerOpen(false)} 
          /> */}
        </ProductModalProvider>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
